// @mui
import { Card, CardHeader, CardContent, Modal } from "@mui/material";
// rls
import { Bars } from "react-loader-spinner";
import { useLocales } from "src/locales";
import { useTheme } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  boxShadow: 24,
  p: 4,
};

const LoadingModal = ({ show = false, title = 'checkout.payment.loading' }) => {
  const { translate } = useLocales();
  const theme = useTheme();

  return (
    <Modal
      open={show ?? false}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <CardHeader
          title={translate(title)}
          style={{ textAlign: "center" }}
        />
        <CardContent style={{ display: "flex", justifyContent: "center" }}>
          <Bars
            height="80"
            width="80"
            radius="9"
            color={theme.palette.primary.main}
            ariaLabel="loading"
            wrapperStyle
          />
        </CardContent>
      </Card>
    </Modal>
  );
};

export default LoadingModal;
